/** @jsx jsx */
import { jsx } from 'theme-ui'
import { Link } from 'gatsby'

export const Logo: React.FC = () => (
  <Link
    to="/"
    style={{
      outline: 'none'
    }}
  >
    <svg id="demo-logo" x="0px" y="0px" viewBox="0 0 205 50" width="150px">
      <g
        sx={{
          fill: 'textSecondary'
        }}
      >
        <path
          d="M68.8,23.6h12.5c0,1.3-0.1,2.5-0.2,3.5c-0.1,1.1-0.3,2-0.6,2.9c-0.5,1.3-1.1,2.4-1.8,3.4c-0.8,1-1.7,1.8-2.7,2.4
		c-1,0.7-2.2,1.2-3.4,1.5c-1.2,0.3-2.6,0.5-3.9,0.5c-1.9,0-3.6-0.3-5.2-0.9c-1.6-0.6-2.9-1.5-4-2.6c-1.1-1.1-2-2.5-2.6-4.1
		c-0.6-1.6-0.9-3.3-0.9-5.2c0-1.9,0.3-3.6,0.9-5.2c0.6-1.6,1.5-2.9,2.6-4c1.1-1.1,2.5-2,4.1-2.6c1.6-0.6,3.4-0.9,5.3-0.9
		c2.5,0,4.8,0.5,6.7,1.6c1.9,1.1,3.4,2.8,4.5,5.1l-6,2.5c-0.6-1.3-1.3-2.3-2.2-2.9c-0.9-0.6-1.9-0.9-3-0.9c-0.9,0-1.8,0.2-2.6,0.5
		c-0.8,0.4-1.4,0.9-2,1.5c-0.5,0.7-1,1.4-1.3,2.4c-0.3,0.9-0.5,2-0.5,3.1c0,1,0.1,2,0.4,2.9c0.3,0.9,0.7,1.6,1.2,2.3
		c0.5,0.6,1.2,1.1,2,1.5c0.8,0.4,1.7,0.5,2.8,0.5c0.6,0,1.2-0.1,1.8-0.2c0.6-0.1,1.1-0.4,1.6-0.7c0.5-0.3,0.8-0.7,1.1-1.2
		c0.3-0.5,0.5-1.1,0.6-1.8h-5.2V23.6z"
        />
        <path
          d="M97.5,20.6h5.9v16.5h-5.9v-1.8c-1.2,1.6-2.9,2.3-5.1,2.3c-1.2,0-2.3-0.2-3.3-0.7c-1-0.4-1.9-1.1-2.6-1.8
		c-0.8-0.8-1.3-1.7-1.8-2.8c-0.4-1.1-0.6-2.2-0.6-3.5c0-1.2,0.2-2.3,0.6-3.4c0.4-1.1,1-2,1.7-2.8c0.7-0.8,1.6-1.4,2.6-1.9
		c1-0.5,2.1-0.7,3.3-0.7c2.1,0,3.8,0.7,5.1,2.2V20.6z M90.2,28.8c0,0.5,0.1,1,0.3,1.5c0.2,0.5,0.5,0.9,0.8,1.2
		c0.3,0.3,0.7,0.6,1.2,0.8c0.5,0.2,1,0.3,1.5,0.3c0.5,0,1-0.1,1.5-0.3c0.5-0.2,0.9-0.5,1.2-0.8c0.3-0.3,0.6-0.7,0.8-1.2
		c0.2-0.5,0.3-0.9,0.3-1.4c0-0.5-0.1-1-0.3-1.5c-0.2-0.5-0.5-0.9-0.8-1.2c-0.3-0.3-0.7-0.6-1.2-0.8c-0.5-0.2-0.9-0.3-1.5-0.3
		c-0.5,0-1,0.1-1.5,0.3c-0.5,0.2-0.9,0.5-1.2,0.8c-0.3,0.3-0.6,0.7-0.8,1.2C90.3,27.8,90.2,28.3,90.2,28.8z"
        />
        <path d="M113.8,25.5v11.6H108V25.5h-1.9v-4.9h1.9v-5h5.8v5h3.3v4.9H113.8z" />
        <path
          d="M133.3,19.1c-0.7-0.6-1.4-1-2.1-1.2c-0.7-0.3-1.4-0.4-2-0.4c-0.8,0-1.5,0.2-2,0.6c-0.5,0.4-0.8,0.9-0.8,1.5
		c0,0.4,0.1,0.8,0.4,1.1c0.3,0.3,0.6,0.5,1,0.7c0.4,0.2,0.9,0.4,1.4,0.5c0.5,0.2,1,0.3,1.6,0.5c2.1,0.7,3.6,1.6,4.5,2.8
		s1.4,2.6,1.4,4.5c0,1.2-0.2,2.4-0.6,3.4c-0.4,1-1,1.9-1.8,2.6c-0.8,0.7-1.8,1.3-3,1.7c-1.2,0.4-2.5,0.6-4,0.6
		c-3.1,0-5.9-0.9-8.5-2.7l2.7-5.1c0.9,0.8,1.9,1.5,2.8,1.9c0.9,0.4,1.8,0.6,2.7,0.6c1,0,1.8-0.2,2.3-0.7c0.5-0.5,0.8-1,0.8-1.6
		c0-0.4-0.1-0.7-0.2-0.9c-0.1-0.3-0.3-0.5-0.6-0.7c-0.3-0.2-0.7-0.4-1.2-0.6c-0.5-0.2-1.1-0.4-1.8-0.6c-0.8-0.3-1.6-0.5-2.4-0.9
		c-0.8-0.3-1.5-0.7-2.1-1.2c-0.6-0.5-1.1-1.2-1.5-1.9c-0.4-0.8-0.6-1.8-0.6-3c0-1.2,0.2-2.3,0.6-3.3c0.4-1,1-1.8,1.7-2.5
		c0.7-0.7,1.6-1.2,2.6-1.6c1-0.4,2.2-0.6,3.5-0.6c1.2,0,2.5,0.2,3.8,0.5c1.3,0.3,2.6,0.8,3.8,1.5L133.3,19.1z"
        />
        <path d="M147,25.5v11.6h-5.8V25.5h-1.9v-4.9h1.9v-5h5.8v5h3.3v4.9H147z" />
        <path
          d="M165.6,20.6h5.9v16.5h-5.9v-1.8c-1.2,1.6-2.9,2.3-5.1,2.3c-1.2,0-2.3-0.2-3.3-0.7c-1-0.4-1.9-1.1-2.6-1.8
		c-0.8-0.8-1.3-1.7-1.8-2.8c-0.4-1.1-0.6-2.2-0.6-3.5c0-1.2,0.2-2.3,0.6-3.4c0.4-1.1,1-2,1.7-2.8c0.7-0.8,1.6-1.4,2.6-1.9
		c1-0.5,2.1-0.7,3.3-0.7c2.1,0,3.8,0.7,5.1,2.2V20.6z M158.3,28.8c0,0.5,0.1,1,0.3,1.5c0.2,0.5,0.5,0.9,0.8,1.2
		c0.3,0.3,0.7,0.6,1.2,0.8c0.5,0.2,1,0.3,1.5,0.3c0.5,0,1-0.1,1.5-0.3c0.5-0.2,0.9-0.5,1.2-0.8c0.3-0.3,0.6-0.7,0.8-1.2
		c0.2-0.5,0.3-0.9,0.3-1.4c0-0.5-0.1-1-0.3-1.5c-0.2-0.5-0.5-0.9-0.8-1.2c-0.3-0.3-0.7-0.6-1.2-0.8c-0.5-0.2-0.9-0.3-1.5-0.3
		c-0.5,0-1,0.1-1.5,0.3c-0.5,0.2-0.9,0.5-1.2,0.8c-0.3,0.3-0.6,0.7-0.8,1.2C158.4,27.8,158.3,28.3,158.3,28.8z"
        />
        <path d="M181.9,25.5v11.6h-5.8V25.5h-1.9v-4.9h1.9v-5h5.8v5h3.3v4.9H181.9z" />
        <path
          d="M198.5,24.9c-1.1-0.6-2.1-0.8-3.2-0.8c-0.5,0-1,0.1-1.3,0.3c-0.3,0.2-0.5,0.5-0.5,0.9c0,0.2,0,0.3,0.1,0.5
		c0.1,0.1,0.2,0.2,0.4,0.3c0.2,0.1,0.5,0.2,0.8,0.3c0.4,0.1,0.8,0.2,1.4,0.3c1.6,0.3,2.8,0.9,3.6,1.7c0.8,0.8,1.2,1.9,1.2,3.2
		c0,1-0.2,1.8-0.6,2.6c-0.4,0.8-0.9,1.4-1.6,1.9c-0.7,0.5-1.5,0.9-2.5,1.2c-1,0.3-2,0.4-3.2,0.4c-2.2,0-4.4-0.6-6.6-1.9l2.1-4.1
		c1.6,1.1,3.2,1.7,4.6,1.7c0.5,0,1-0.1,1.3-0.4c0.3-0.2,0.5-0.5,0.5-0.9c0-0.2,0-0.4-0.1-0.5c-0.1-0.1-0.2-0.3-0.3-0.4
		c-0.2-0.1-0.4-0.2-0.8-0.3c-0.3-0.1-0.8-0.2-1.3-0.3c-1.8-0.4-3.1-0.9-3.8-1.6c-0.7-0.7-1.1-1.7-1.1-3c0-0.9,0.2-1.8,0.5-2.5
		c0.3-0.7,0.8-1.4,1.5-1.9c0.6-0.5,1.4-0.9,2.3-1.2c0.9-0.3,1.9-0.4,3-0.4c1.8,0,3.6,0.4,5.3,1.1L198.5,24.9z"
        />
      </g>

      <path
        sx={{
          fill: 'textSecondary'
        }}
        d="M35.6,23.9H24.6v4.4h5.8c-1,3-3.1,5-7.3,5c-4.6,0-7.9-3.8-7.9-8.3s3.1-8.5,7.7-8.5c2.5,0,5,1.3,6.6,3.3l3.6-2.4
	c-2.4-3.3-6.2-5.2-10.3-5.2c-7,0-12.6,5.7-12.6,12.7S15.7,37.7,23,37.7S35.6,32,35.6,24.9C35.6,24.5,35.6,23.9,35.6,23.9z"
      />
      <path
        sx={{
          fill: 'primary'
        }}
        d="M5,25c0-9.9,8.1-18,18-18c0,0,0,0,0,0V2C17.2,2,12.3,3.9,7.9,7.6C-1.7,16-2.7,30.5,5.6,40.1l3.8-3.3
	C6.7,33.6,5,29.5,5,25z"
      />
      <path
        sx={{
          fill: 'textMuted'
        }}
        d="M23,43c-5.4,0-10.3-2.4-13.6-6.2l-3.8,3.3c0.8,0.9,1.7,1.8,2.6,2.5c9.7,8.2,24.2,6.9,32.4-2.8l-3.8-3.2
	C33.5,40.5,28.5,43,23,43z"
      />
      <path
        sx={{
          fill: 'secondary'
        }}
        d="M23,2v5c9.9,0,18,8.1,18,18c0,4.4-1.6,8.4-4.2,11.6l3.8,3.2c3.7-4.4,5.4-9,5.4-14.8C46,12.3,35.7,2,23,2z"
      />
    </svg>
  </Link>
)
